export default __webpack_public_path__ + "static/media/noimage.b0ab9a5e.png";